<div class="animated fadeIn">
  <div class="row mt-3">
    <div class="col">
      <div class="row">
        <div class="col text-center">
          <h4 class="mt-2">Please Select A Bespoke Template</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-4" *ngFor="let template of templates">
          <div class="card m-2">
            <img class="card-img-top" src="{{template.url}}" alt="">
            <div class="card-body text-center">
              <h5 class="card-title">{{ template.name }}</h5>
              <p class="card-text">{{ template.description }}</p>
              <a (click)="createQuote(template.id)" class="btn btn-success">Select</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
